module.exports = __webpack_public_path__ + "static/ball_1-b80c235524b021ca02ce67c2ea3c8204.png";